import CASBlock from "@blocks/CASBlock/CASBlock";
import GAData, { GADataProps } from "@elements/GAData/GAData";
import MetaTags, { MetaTagsProps } from "@elements/MetaTags/MetaTags";
import { CAS_ALL_PAGE_CAMPAIGN_ID } from "@helper/getEnvVariables";
import { useNeuronPageViewPush } from "@hooks/useAnalyticsCall/useNeuronPageViewPush";
import useCasScript from "@hooks/useCasScript";
import useOKTAUserInfo from "@hooks/useOktaUserInfo";
import useRemoveOverlay from "@hooks/useRemoveOverlay";
import useScript from "@hooks/useScript";
import useSendPermutiveIdentify from "@hooks/useSendPermutiveIdentify";
import { ReactElement, ReactNode } from "react";

export type AdsSettings = {
  isPrestitialEnabled: boolean | undefined;
  isCatfishEnabled: boolean | undefined;
  isOutbrainEnabled: boolean | undefined;
};

export type QuickNewsMainProps = Readonly<{
  testId?: string;
  children: ReactNode;
  gaData?: GADataProps;
  metaTagsProps?: MetaTagsProps;
  sectionName?: string;
  hasLb1Ads?: boolean;
  mobwebview?: boolean;
  pageAdTargetValue: string;
  suppliedAdsSettings: AdsSettings;
  gsChannels?: string[];
  geHomeWidget?: boolean;
  isArticlePage?: boolean;
}>;

export default function QuickNewsContainer({
  children,
  testId = "main-container-quick-news",
  gaData,
  metaTagsProps,
}: QuickNewsMainProps): ReactElement {
  useRemoveOverlay();
  useOKTAUserInfo();
  useScript({
    id: "mysph-lightbox-lib",
    src: import.meta.env.VITE_SPH_LIGHTBOX as string,
  });
  useNeuronPageViewPush();
  useSendPermutiveIdentify();
  const { isScriptReady: isCasScriptReady } = useCasScript();

  return (
    <div
      data-testid={testId}
      className="max-w-screen relative mx-auto flex h-svh w-screen flex-col overflow-hidden bg-[linear-gradient(168deg,#272727_0%,#101010_100%)] blur-0"
    >
      {isCasScriptReady && CAS_ALL_PAGE_CAMPAIGN_ID && (
        <CASBlock casId={CAS_ALL_PAGE_CAMPAIGN_ID} />
      )}

      {gaData && <GAData {...gaData} />}
      {metaTagsProps && <MetaTags {...metaTagsProps} />}
      {children}
    </div>
  );
}
